export function stripMarkdownFrontmatter(markdown) {
  return String(markdown || '').replace(/^---\s*\n[\s\S]*?\n---\s*\n?/, '');
}

const CTA_TEXT_PATTERN = /\b(research|build|backtest|browse|marketplace|ask spot)\b/i;
const BOTSPOT_HOST_PATTERN = /(^|\.)botspot\.trade$/i;

function isBotSpotUrl(href) {
  if (!href) return false;

  try {
    const url = new URL(href, 'https://botspot.trade');
    return BOTSPOT_HOST_PATTERN.test(url.hostname);
  } catch {
    return false;
  }
}

function isPrimaryAction(text, href) {
  return /\b(build|backtest|research)\b/i.test(text) || /\/ai-agent\b/i.test(href);
}

export function decorateBlogArticleHtml(html) {
  const articleHtml = String(html || '');

  if (typeof DOMParser === 'undefined') {
    return articleHtml;
  }

  const document = new DOMParser().parseFromString(`<div>${articleHtml}</div>`, 'text/html');
  const wrapper = document.body.firstElementChild;

  if (!wrapper) return articleHtml;

  wrapper.querySelectorAll('a[href]').forEach((anchor) => {
    const href = anchor.getAttribute('href') || '';
    const text = anchor.textContent || '';
    const isCtaLink = isBotSpotUrl(href) && (CTA_TEXT_PATTERN.test(text) || /\/(ai-agent|marketplace)\b/i.test(href));

    if (isCtaLink) {
      anchor.classList.add('blog-cta-button');

      if (isPrimaryAction(text, href)) {
        anchor.classList.add('primary-action');
      }
    }

    if (/^https?:\/\//i.test(href)) {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    }
  });

  return wrapper.innerHTML;
}
